import React from "react";

import "./styles.scss";
import ESGChatMain from "../esg-chat/esg-chat";

const CompanyResearchMain = () => {
    return (
        <div className="company-research-main">
            <ESGChatMain
                searchType="Company"
                showDisclosuresSection
            />
        </div>
    )
}

export default CompanyResearchMain